<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_ix"></a><strong>World War II and Mexican American Civil Rights</strong></p>
<p class="noindent"><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?4f5417f6